"use client"

import { Edit2, Trash2, ChevronRight } from "lucide-react"
import { Button } from "../../../components/ui/button"
import { Card } from "../../../components/ui/card"
import type { Category } from "./categories"

type CategoryListProps = {
  categories: Category[]
  onEdit: (category: Category) => void
  onDelete: (id: string) => void
  onClick: (category: Category) => void
}

export function CategoryList({ categories, onEdit, onDelete, onClick }: CategoryListProps) {
  if (categories.length === 0) {
    return (
      <Card className="border-dashed bg-card/50 p-12 text-center">
        <p className="text-lg text-muted-foreground">
          Nenhuma categoria cadastrada. Clique em "Nova Categoria" para começar.
        </p>
      </Card>
    )
  }

  return (
    <div className="space-y-3">
      {categories.map((category) => (
        <Card
          key={category.id}
          className="group flex items-center justify-between bg-card p-4 transition-all hover:border-primary/50 hover:bg-card/80"
        >
          <button onClick={() => onClick(category)} className="flex flex-1 items-center gap-3 text-left">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <span className="text-xl font-bold">{category.name.charAt(0).toUpperCase()}</span>
            </div>
            <div className="flex-1">
              <h3 className="font-sans text-lg font-semibold text-foreground">{category.name}</h3>
              <p className="text-sm text-muted-foreground">Clique para ver os kits</p>
            </div>
            <ChevronRight className="h-5 w-5 text-muted-foreground transition-transform group-hover:translate-x-1" />
          </button>
          <div className="ml-4 flex gap-2">
            <Button
              variant="ghost"
              size="icon"
              onClick={(e) => {
                e.stopPropagation()
                onEdit(category)
              }}
              className="text-muted-foreground hover:text-foreground"
            >
              <Edit2 className="h-4 w-4" />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={(e) => {
                e.stopPropagation()
                onDelete(category.id)
              }}
              className="text-muted-foreground hover:text-destructive"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </Card>
      ))}
    </div>
  )
}